import 'core-js/actual/set';
import 'core-js/actual/array';

// Стили
import 'vue-toast-notification/dist/theme-default.css';
import '@/assets/style/main.scss';

import Core from "@/core/Core";

// Запускаем инициализацию
Core.initialize();
